import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { change_Current_Location, changeHeaderTitle } from '../../store';
import axios from 'axios';
import { MessageModal } from '../component/modal/modal';
import { LoadingModal } from '../component/modal/modal';
import List from '../component/list/list';
import Layout from './components/Layout';
import dayjs from 'dayjs';
import { changeNum, convertDateFormat } from '../common/function';
import './styles/v2.css';

function PaylistV2() {
    let navigate = useNavigate();
    let dispatch = useDispatch();
    let MyData = useSelector((state) => state.MyData);

    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [maxFirstPage, setMaxFirstPage] = useState(40);
    const [spinner, setSpinner] = useState(false);
    const [listData, setListData] = useState({});
    const [listTrxData, setListTrxData] = useState([]);
    const [combineData, setCombineData] = useState([]);
    const [reload, setReload] = useState(false);
    const [message, setMessage] = useState("");

    // 날짜 상태
    const [preDate, setPreDate] = useState(dayjs().startOf('month').format('YYYY-MM-DD'));
    const [nextDate, setNextDate] = useState(dayjs().endOf('month').format('YYYY-MM-DD'));

    // 컬럼별 필터 상태
    const [columnFilters, setColumnFilters] = useState({
        trxDate: "",
        approvalId: "",
        merchantNm: "",
        amt: ""
    });

    // 활성화된 빠른 필터 추적
    const [activeQuickFilter, setActiveQuickFilter] = useState(null);

    const [listState, setListState] = useState(false);
    const observerRef = useRef(null);

    // PG 선택 (0: 전체, 1: K-WON, 2: WGP)
    const [pgSelect, setPGSelect] = useState(0);

    useEffect(() => {
        dispatch(change_Current_Location("거래내역"));
        dispatch(changeHeaderTitle({
            mainTitle: "거래조회 (V2)"
        }));

        setTimeout(() => {
            setLoading(false);
        }, 500);
    }, [dispatch]);

    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate);
        setNextDate(endDate);
        setPage(1);
        setReload(e => !e);
    };

    useEffect(() => {
        if (pgSelect > -1) {
            ListData();
        }
    }, [reload, pgSelect, page, maxFirstPage, preDate, nextDate]);

    const ListData = async () => {
        if (page === 1) setSpinner(true);
        else setSpinner(true);

        await axios.get(process.env.REACT_APP_API + "/api/trx", {
            withCredentials: true,
            params: {
                page: page,
                limit: maxFirstPage,
                pg: pgSelect === 0 ? "" : pgSelect === 1 ? "K" : "O",
                startDate: preDate,
                endDate: nextDate,
            }
        }).then((response) => {
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setListData(tmp?.data ?? {});
                if (page === 1) {
                    setListTrxData(tmp?.data?.trx ?? []);
                } else {
                    setListTrxData((prev) => [...prev, ...tmp?.data?.trx ?? []]);
                }
                setListState(e => !e);
            } else if (tmp?.code === 9999) {
                setMessage({ msg: "세션이 만료되었습니다." });
            }
            setSpinner(false);
        }).catch(error => {
            console.error(error);
            setMessage({ msg: "데이터 조회에 실패했습니다." });
            setSpinner(false);
        });
    };

    // 컬럼별 필터링 함수
    const filterDataByColumns = (data) => {
        if (!data || data.length === 0) return data;
        
        return data.filter((item) => {
            // 거래일 필터
            if (columnFilters.trxDate) {
                const dateStr = item?.cancel_date ? convertDateFormat(item.cancel_date) : convertDateFormat(item.trx_date);
                if (!dateStr?.includes(columnFilters.trxDate)) {
                    return false;
                }
            }
            // 승인번호 필터
            if (columnFilters.approvalId && !item.approval_id?.toString().includes(columnFilters.approvalId)) {
                return false;
            }
            // 가맹점명 필터
            if (columnFilters.merchantNm && !item.merchant_nm?.toString().includes(columnFilters.merchantNm)) {
                return false;
            }
            // 금액 필터
            if (columnFilters.amt && !changeNum(item.amt)?.toString().includes(columnFilters.amt)) {
                return false;
            }
            return true;
        });
    };

    const tableHeaderData = MyData?.role === "SUPER" ?
        [
            {
                "no": 5,
                "text": (
                    <div style={{ padding: "4px" }}>
                        <input
                            type="text"
                            placeholder="승인일/취소일"
                            value={columnFilters.trxDate}
                            onChange={(e) => setColumnFilters({...columnFilters, trxDate: e.target.value})}
                            onClick={(e) => e.stopPropagation()}
                            className="column-filter-input"
                            style={{
                                width: "100%",
                                height: "24px",
                                padding: "0 4px",
                                fontSize: "11px"
                            }}
                        />
                    </div>
                ),
                "width": "120px",
                "textAlign": "center"
            },
            {
                "no": 4,
                "text": (
                    <div style={{ padding: "4px" }}>
                        <input
                            type="text"
                            placeholder="승인번호"
                            value={columnFilters.approvalId}
                            onChange={(e) => setColumnFilters({...columnFilters, approvalId: e.target.value})}
                            onClick={(e) => e.stopPropagation()}
                            className="column-filter-input"
                            style={{
                                width: "100%",
                                height: "24px",
                                padding: "0 4px",
                                fontSize: "11px"
                            }}
                        />
                    </div>
                ),
                "width": "120px",
                "textAlign": "center"
            },
            {
                "no": 2,
                "text": (
                    <div style={{ padding: "4px" }}>
                        <input
                            type="text"
                            placeholder="가맹점명"
                            value={columnFilters.merchantNm}
                            onChange={(e) => setColumnFilters({...columnFilters, merchantNm: e.target.value})}
                            onClick={(e) => e.stopPropagation()}
                            className="column-filter-input"
                            style={{
                                width: "100%",
                                height: "24px",
                                padding: "0 4px",
                                fontSize: "11px"
                            }}
                        />
                    </div>
                ),
                "width": "180px",
                "textAlign": "left"
            },
            {
                "no": 7,
                "text": (
                    <div style={{ padding: "4px" }}>
                        <input
                            type="text"
                            placeholder="거래금액"
                            value={columnFilters.amt}
                            onChange={(e) => setColumnFilters({...columnFilters, amt: e.target.value})}
                            onClick={(e) => e.stopPropagation()}
                            className="column-filter-input"
                            style={{
                                width: "100%",
                                height: "24px",
                                padding: "0 4px",
                                fontSize: "11px"
                            }}
                        />
                    </div>
                ),
                "width": "120px",
                "textAlign": "right"
            },
            {
                "no": 8,
                "text": "결제구분",
                "width": "100px",
                "textAlign": "center"
            },
            {
                "no": 6,
                "text": "",
                "width": "auto",
                "textAlign": "left",
                "skeleton": true
            },
        ]
        :
        [
            {
                "no": 13,
                "text": "전표",
                "width": "50px",
                "textAlign": "center"
            },
            {
                "no": 5,
                "text": (
                    <div style={{ padding: "4px" }}>
                        <input
                            type="text"
                            placeholder="승인일/취소일"
                            value={columnFilters.trxDate}
                            onChange={(e) => setColumnFilters({...columnFilters, trxDate: e.target.value})}
                            onClick={(e) => e.stopPropagation()}
                            className="column-filter-input"
                            style={{
                                width: "100%",
                                height: "24px",
                                padding: "0 4px",
                                fontSize: "11px"
                            }}
                        />
                    </div>
                ),
                "width": "120px",
                "textAlign": "center"
            },
            {
                "no": 7,
                "text": (
                    <div style={{ padding: "4px" }}>
                        <input
                            type="text"
                            placeholder="거래금액"
                            value={columnFilters.amt}
                            onChange={(e) => setColumnFilters({...columnFilters, amt: e.target.value})}
                            onClick={(e) => e.stopPropagation()}
                            className="column-filter-input"
                            style={{
                                width: "100%",
                                height: "24px",
                                padding: "0 4px",
                                fontSize: "11px"
                            }}
                        />
                    </div>
                ),
                "width": "120px",
                "textAlign": "right"
            },
            {
                "no": 9,
                "text": "카드번호",
                "width": "150px",
                "textAlign": "center"
            },
            {
                "no": 2,
                "text": (
                    <div style={{ padding: "4px" }}>
                        <input
                            type="text"
                            placeholder="가맹점명"
                            value={columnFilters.merchantNm}
                            onChange={(e) => setColumnFilters({...columnFilters, merchantNm: e.target.value})}
                            onClick={(e) => e.stopPropagation()}
                            className="column-filter-input"
                            style={{
                                width: "100%",
                                height: "24px",
                                padding: "0 4px",
                                fontSize: "11px"
                            }}
                        />
                    </div>
                ),
                "width": "180px",
                "textAlign": "left"
            },
            {
                "no": 10,
                "text": "할부",
                "width": "80px",
                "textAlign": "center"
            },
            {
                "no": 17,
                "text": "출금여부",
                "width": "100px",
                "textAlign": "center"
            },
            {
                "no": 6,
                "text": "",
                "width": "auto",
                "textAlign": "left",
                "skeleton": true
            },
        ];

    useEffect(() => {
        let tableBodyData = [];
        let filteredData = filterDataByColumns(listTrxData);
        
        if (filteredData) {
            for (let i = 0; i < filteredData.length; i++) {
                let data = filteredData[i];

                let rowData = MyData?.role === "SUPER" ?
                    [
                        { 
                            "no": 5, 
                            "text": data?.cancel_date ? convertDateFormat(data.cancel_date) : convertDateFormat(data.trx_date), 
                            "width": "120px", 
                            "textAlign": "center" 
                        },
                        { "no": 4, "text": data.approval_id, "width": "120px", "textAlign": "center" },
                        { "no": 2, "text": data.merchant_nm, "width": "180px", "textAlign": "left" },
                        { "no": 7, "text": `${changeNum(data.amt)}원`, "width": "120px", "textAlign": "right" },
                        { "no": 8, "text": data.payment_type, "width": "100px", "textAlign": "center" },
                        {
                            "no": 6,
                            "text": "",
                            "width": "auto",
                            "textAlign": "left",
                            "skeleton": true
                        },
                    ]
                    :
                    [
                        {
                            "no": 13,
                            "text": (
                                <div className='pointer list-text-center'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: "#0a6e0a" }}>
                                        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                                        <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                                    </svg>
                                </div>
                            ),
                            "width": "50px",
                            "textAlign": "center"
                        },
                        { 
                            "no": 5, 
                            "text": data?.cancel_date ? convertDateFormat(data.cancel_date) : convertDateFormat(data.trx_date), 
                            "width": "120px", 
                            "textAlign": "center" 
                        },
                        { "no": 7, "text": `${changeNum(data.amt)}원`, "width": "120px", "textAlign": "right" },
                        { "no": 9, "text": data.card_num, "width": "150px", "textAlign": "center" },
                        { "no": 2, "text": data.merchant_nm, "width": "180px", "textAlign": "left" },
                        { "no": 10, "text": data.quota === "00" ? "일시불" : `${Number(data.quota)}개월`, "width": "80px", "textAlign": "center" },
                        {
                            "no": 17,
                            "text": (
                                <span style={{ color: data.withdraw_yn === 1 ? "#0a6e0a" : undefined }}>
                                    {data.withdraw_yn === 1 ? "출금" : "-"}
                                </span>
                            ),
                            "width": "100px",
                            "textAlign": "center"
                        },
                        {
                            "no": 6,
                            "text": "",
                            "width": "auto",
                            "textAlign": "left",
                            "skeleton": true
                        },
                    ];

                rowData.cancel_date = data.cancel_date;
                rowData.id = MyData?.role === "SUPER" ? data.id : "";
                rowData.amount = data.amt;

                tableBodyData.push(rowData);
            }
            setListState(e => !e);
            setCombineData(tableBodyData);
        }
    }, [listTrxData, reload, columnFilters, MyData]);

    useEffect(() => {
        if (combineData.length === 0) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && listData.total >= page * maxFirstPage) {
                setPage((prev) => prev + 1);
            }
        });

        if (observerRef.current) {
            observer.observe(observerRef.current);
        }

        return () => {
            if (observerRef.current) {
                observer.unobserve(observerRef.current);
            }
        };
    }, [combineData, listData, page, maxFirstPage]);

    const excelBtn = async () => {
        await axios.get(process.env.REACT_APP_API + "/api/trx/excel", {
            withCredentials: true,
            params: {
                pg: pgSelect === 0 ? "" : pgSelect === 1 ? "K" : "O",
                startDate: preDate,
                endDate: nextDate,
            }
        }).then((response) => {
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                // 엑셀 다운로드 로직 (기존 paylist.js 참고)
                setMessage({ msg: "엑셀 다운로드가 완료되었습니다." });
            } else {
                setMessage({ msg: "엑셀 다운로드에 실패했습니다." });
            }
        }).catch(error => {
            console.error(error);
            setMessage({ msg: "엑셀 다운로드에 실패했습니다." });
        });
    };

    // 빠른 필터 버튼
    const quickFilters = [
        { label: "오늘", value: "", date: "today" },
        { label: "어제", value: "", date: "yesterday" },
        { label: "최근 7일", value: "", date: "7days" },
        { label: "최근 30일", value: "", date: "30days" },
        { label: "이번 달", value: "", date: "thisMonth" },
    ];

    const applyQuickFilter = (filter, index) => {
        if (activeQuickFilter === index) {
            setActiveQuickFilter(null);
            const today = dayjs();
            setPreDate(today.startOf('month').format('YYYY-MM-DD'));
            setNextDate(today.endOf('month').format('YYYY-MM-DD'));
            setDateRange(today.startOf('month').format('YYYY-MM-DD'), today.endOf('month').format('YYYY-MM-DD'));
        } else {
            setActiveQuickFilter(index);
            const today = dayjs();
            let startDate, endDate;

            if (filter.date === "today") {
                startDate = today.format('YYYY-MM-DD');
                endDate = today.format('YYYY-MM-DD');
            } else if (filter.date === "yesterday") {
                const yesterday = today.subtract(1, 'day');
                startDate = yesterday.format('YYYY-MM-DD');
                endDate = yesterday.format('YYYY-MM-DD');
            } else if (filter.date === "7days") {
                startDate = today.subtract(7, 'day').format('YYYY-MM-DD');
                endDate = today.format('YYYY-MM-DD');
            } else if (filter.date === "30days") {
                startDate = today.subtract(30, 'day').format('YYYY-MM-DD');
                endDate = today.format('YYYY-MM-DD');
            } else if (filter.date === "thisMonth") {
                startDate = today.startOf('month').format('YYYY-MM-DD');
                endDate = today.endOf('month').format('YYYY-MM-DD');
            }

            setDateRange(startDate, endDate);
        }
    };

    return (
        <Layout>
            <style>{`
                .column-filter-input {
                    background: #f5f5f5 !important;
                    border: 1px solid #ccc !important;
                }
                .column-filter-input:focus {
                    background: white !important;
                    border: 1px solid #999 !important;
                    outline: none !important;
                }
                .column-filter-input::placeholder {
                    color: #666 !important;
                    font-weight: 500 !important;
                    opacity: 1 !important;
                }
                .column-filter-input::-webkit-input-placeholder {
                    color: #666 !important;
                    font-weight: 500 !important;
                    opacity: 1 !important;
                }
                .column-filter-input::-moz-placeholder {
                    color: #666 !important;
                    font-weight: 500 !important;
                    opacity: 1 !important;
                }
                .column-filter-input:-ms-input-placeholder {
                    color: #666 !important;
                    font-weight: 500 !important;
                    opacity: 1 !important;
                }
            `}</style>
            {loading ? <LoadingModal /> : ""}
            <MessageModal message={message} />
            
            <div style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                height: '100%', 
                overflow: 'hidden',
                padding: '16px',
                gap: '12px'
            }}>
                {/* 빠른 필터 및 PG 선택 영역 */}
                <div style={{ 
                    background: "#f9fafb", 
                    border: "1px solid #d1d5db", 
                    padding: "12px",
                    flexShrink: 0
                }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "12px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                            <span style={{ fontSize: "12px", color: "#666", fontWeight: "500" }}>빠른 필터:</span>
                            {quickFilters.map((filter, idx) => (
                                <button
                                    key={idx}
                                    style={{
                                        padding: "6px 12px",
                                        fontSize: "12px",
                                        background: activeQuickFilter === idx ? "#3b82f6" : "white",
                                        border: "1px solid #d1d5db",
                                        cursor: "pointer",
                                        color: activeQuickFilter === idx ? "white" : "#333"
                                    }}
                                    onClick={() => applyQuickFilter(filter, idx)}
                                    onMouseOver={(e) => {
                                        if (activeQuickFilter !== idx) {
                                            e.target.style.background = "#f0f0f0";
                                        }
                                    }}
                                    onMouseOut={(e) => {
                                        if (activeQuickFilter !== idx) {
                                            e.target.style.background = "white";
                                        }
                                    }}
                                >
                                    {filter.label}
                                </button>
                            ))}
                            <button
                                style={{
                                    padding: "6px 12px",
                                    fontSize: "12px",
                                    background: "white",
                                    border: "1px solid #d1d5db",
                                    cursor: "pointer",
                                    color: "#333"
                                }}
                                onClick={() => {
                                    setActiveQuickFilter(null);
                                    const today = dayjs();
                                    setPreDate(today.startOf('month').format('YYYY-MM-DD'));
                                    setNextDate(today.endOf('month').format('YYYY-MM-DD'));
                                    setDateRange(today.startOf('month').format('YYYY-MM-DD'), today.endOf('month').format('YYYY-MM-DD'));
                                }}
                                onMouseOver={(e) => e.target.style.background = "#f0f0f0"}
                                onMouseOut={(e) => e.target.style.background = "white"}
                            >
                                초기화
                            </button>
                        </div>
                        
                        {/* PG 선택 */}
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <span style={{ fontSize: "12px", color: "#666", fontWeight: "500" }}>PG:</span>
                            <button
                                style={{
                                    padding: "6px 12px",
                                    fontSize: "12px",
                                    background: pgSelect === 0 ? "#3b82f6" : "white",
                                    border: "1px solid #d1d5db",
                                    cursor: "pointer",
                                    color: pgSelect === 0 ? "white" : "#333"
                                }}
                                onClick={() => {
                                    setPGSelect(0);
                                    setPage(1);
                                    setReload(e => !e);
                                }}
                            >
                                전체
                            </button>
                            <button
                                style={{
                                    padding: "6px 12px",
                                    fontSize: "12px",
                                    background: pgSelect === 1 ? "#3b82f6" : "white",
                                    border: "1px solid #d1d5db",
                                    cursor: "pointer",
                                    color: pgSelect === 1 ? "white" : "#333"
                                }}
                                onClick={() => {
                                    setPGSelect(1);
                                    setPage(1);
                                    setReload(e => !e);
                                }}
                            >
                                K-WON
                            </button>
                            <button
                                style={{
                                    padding: "6px 12px",
                                    fontSize: "12px",
                                    background: pgSelect === 2 ? "#3b82f6" : "white",
                                    border: "1px solid #d1d5db",
                                    cursor: "pointer",
                                    color: pgSelect === 2 ? "white" : "#333"
                                }}
                                onClick={() => {
                                    setPGSelect(2);
                                    setPage(1);
                                    setReload(e => !e);
                                }}
                            >
                                WGP
                            </button>
                        </div>
                    </div>
                </div>

                {/* 통계 요약 및 테이블 영역 */}
                <div style={{ 
                    background: "white", 
                    border: "1px solid #d1d5db", 
                    display: "flex", 
                    flexDirection: "column", 
                    overflow: "hidden",
                    flex: 1,
                    minHeight: 0
                }}>
                    {/* 통계 요약 */}
                    <div style={{ 
                        display: "flex", 
                        justifyContent: "space-between", 
                        alignItems: "center", 
                        padding: "8px 12px", 
                        background: "#f5f5f5", 
                        borderBottom: "1px solid #d1d5db", 
                        fontSize: "12px",
                        flexShrink: 0,
                        flexWrap: "wrap",
                        gap: "12px"
                    }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "16px", flexWrap: "wrap" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <span style={{ color: "#666" }}>총 건수:</span>
                                <span style={{ fontWeight: "bold", color: "#333" }}>{changeNum(listData.total || 0)}건</span>
                            </div>
                        </div>
                        <button
                            onClick={excelBtn}
                            style={{
                                padding: "6px 12px",
                                fontSize: "12px",
                                background: "white",
                                border: "1px solid #999",
                                cursor: "pointer",
                                color: "#333"
                            }}
                            onMouseOver={(e) => e.target.style.background = "#f0f0f0"}
                            onMouseOut={(e) => e.target.style.background = "white"}
                        >
                            엑셀 다운로드
                        </button>
                    </div>

                    {/* 테이블 영역 */}
                    <div style={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
                        <List
                            tableHeaderData={tableHeaderData}
                            tableBodyData={listData?.total ?? 0}
                            filter_tableBodyData={combineData}
                            page={page}
                            setPage={setPage}
                            maxFirstPage={maxFirstPage}
                            listType={true}
                            listState={listState}
                            observerRef={observerRef}
                            nonePage={false}
                            scrollState={true}
                            height={"100%"}
                            spinner={spinner}
                        />
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default PaylistV2;
